import { Customer } from '@/core/collections/contracts-api/customers/customer.interface';
import { useStore } from '@/core/hooks/useStore';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export interface FieldKey {
   key: string;
   translation: string;
   display_key?: string;
   max_length?: number;

   optionsUrl?: string;
   options?: Array<any>;
}

export function useContractTemplateConditionKeys() {
   const { t, locale } = useI18n();
   const { state } = useStore();

   const customer = inject('customer', ref({} as Customer));

   const CALCULATED_FIELD_CONDITION_TYPE_KEYS = computed<Array<FieldKey>>(() => [
      {
         key: 'worker_statute',
         translation: t('contracts.statute'),
         display_key: `name.${locale.value}`,
         options: state.workerStatute?.workerStatutes || [],
      },
      {
         key: 'age_range',
         translation: t('generic.age-range'),
      },
      {
         key: 'job_function',
         translation: t('contracts.job-function'),
         display_key: `preferred_label`,
         optionsUrl: 'jobFunction/searchJobFunctions',
      },
      {
         key: 'worker_type',
         translation: t('contracts.worker-type'),
         display_key: `name.${locale.value}`,
         options: state.workerType?.workerTypes || [],
      },
      {
         key: 'cost_center',
         translation: t('companies.cost-centers.cost-center'),
         options: customer.value.company.cost_centers || [],
      },
   ]);

   return {
      CALCULATED_FIELD_CONDITION_TYPE_KEYS: CALCULATED_FIELD_CONDITION_TYPE_KEYS.value,
   };
}
